import React, { useState, useEffect } from 'react';
import ContactServices from '../services/ContactServices';
import useAsync from '../hooks/useAsync';

function Refer() {
  const { data, error, isLoading } = useAsync(ContactServices.getRefer);

  const [formValues, setFormValues] = useState({
    point: '',
    usePoint:'',
    work: [''],
  });

  useEffect(() => {
    if (data?.data) {
      setFormValues({
        point: data.data.point || '',
        usePoint: data.data.usePoint || '',
        work: data.data.work || [],
      });
    }
  }, [data]);

  const handleWorkChange = (index, event) => {
    const updatedWork = formValues.work.map((work, i) =>
      i === index ? event.target.value : work
    );
    setFormValues({
      ...formValues,
      work: updatedWork,
    });
  };

  const addWork = () => {
    setFormValues({
      ...formValues,
      work: [...formValues.work, ''],
    });
  };

  const removeWork = (index) => {
    const updatedWork = formValues.work.filter((_, i) => i !== index);
    setFormValues({
      ...formValues,
      work: updatedWork,
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await ContactServices.updateRefer(data.data._id, formValues);
      alert('Refer & Earn details updated successfully');
    } catch (error) {
      console.error('Failed to update Refer & Earn details', error);
      alert('Failed to update Refer & Earn details');
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading Refer & Earn details</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Refer & Earn</h2>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Refer Point</label>
                    <input
                      type="number"
                      name="point"
                      className="form-control"
                      value={formValues.point}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Use Refer Point</label>
                    <input
                      type="number"
                      name="usePoint"
                      className="form-control"
                      value={formValues.usePoint}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field">
                    <label>How It Works</label>
                    {formValues.work.map((work, index) => (
                      <div key={index} className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          value={work}
                          onChange={(event) => handleWorkChange(index, event)}
                          placeholder="Work description"
                          required
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeWork(index)}
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="btn btn-secondary mt-2"
                      onClick={addWork}
                    >
                      + Add Work
                    </button>
                  </div>
                </div>
              </div>
              <button type="submit" className="site-btn-green">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Refer;
